<template>
	<div class="exception-body  error">
		<div class="exception-panel"></div>

		<div class="exception-content">
			<img src="assets/layout/images/logo_tribunal.png"/>
			<h1><span class="exception-name">ERRO</span> OCORREU</h1>
			<p>Alguma coisa deu errado</p>
			<a @click="goDashboard">Voltar para o ínicio</a>
		</div>
	</div>
</template>

<script>
	export default {
		methods: {
			goDashboard(){
				window.location = "/#/"
			}
		}
	}
</script>

<style scoped>

</style>